/**
 * IMPORTANT
 * Blog content is synced into `src/client-content/` via:
 * - `pnpm sync:client-content`
 */

import type {
  BlogPost as ClientBlogPost,
} from '@/client-content/blog/_data/mock-posts'
import {
  mockPosts as clientMockPosts,
  getPostBySlug as getClientPostBySlug,
  BLOG_CATEGORIES,
} from '@/client-content/blog/_data/mock-posts'

export type BlogPost = ClientBlogPost

export function getBlogPosts(): BlogPost[] {
  return clientMockPosts
}

export function getBlogPostBySlug(slug: string): BlogPost | undefined {
  return getClientPostBySlug(slug)
}

export function getBlogPageCounts(): { hub: number; posts: number; total: number } {
  const hub = 1
  const posts = clientMockPosts.length
  return { hub, posts, total: hub + posts }
}

export { BLOG_CATEGORIES }

